import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled from 'styled-components'
import vars from 'li-components/lib/styles'
import { pathnameIncludes } from '../../util'

const Container = styled.li`
  min-width: 105px;
  min-height: 50px;
  text-align: center;
  border-bottom: 5px solid
    ${p => (p.active ? vars.brandPrimary : 'transparent')};
  transition: background-color 0.2s;

  &.AppLink a {
    color: ${p => (p.active ? vars.gray : vars.grayLight)};
    height: 100%;
    padding-top: 26px;
    transition: color 0.2s;
    text-transform: uppercase;
    font-size: 16px;
  }

  &:hover {
    background-color: ${vars.grayLighter};

    a {
      color: ${vars.gray};
    }
  }
`

const AppLink = ({ href, id, text, ...rest }, { appId, isActiveAppLink }) => {
  const isExternal = id != null && id !== appId
  const isActive = (isActiveAppLink || pathnameIncludes)(href)

  return (
    <Container
      className={`AppLink ${isActive ? 'active' : ''}`}
      active={isActive}
      {...rest}
    >
      {isExternal ? <a href={href}>{text}</a> : <Link to={href}>{text}</Link>}
    </Container>
  )
}

AppLink.propTypes = {
  id: PropTypes.string,
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

AppLink.contextTypes = {
  appId: PropTypes.string.isRequired,
  isActiveAppLink: PropTypes.func,
}

export default AppLink



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/AppLink.js